import AbstractService from "./AbstractService";

class JwtAuthService extends AbstractService {

  static _getUrl(partUrl) {
    return `/rest/v1${partUrl}`;
  }

  static async login(data) {
    const {
      email: username,
      password
    } = data;

    const url = this._getUrl(`/login`);
    return await this._setResource(url,
      {
        headers: {
          'public-request': 'true',
        },
        data: {username, password}
      });
  }

  static async logout() {
    const url = this._getUrl(`/logout`);
    return await this._setResource(url,
      {
        headers: {
          'public-request': 'true',
        },
      });
  }

  static async getAllowedUrls(mask) {
    const url = this._getUrl(`/get-allowed-urls` + (mask ? `?mask=${mask}` : ''));
    const resp = await this._getResource(url);

    return resp?.results ?? [];

  }
}

export default JwtAuthService;